// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as Inline from "./Inline.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function BarControl(props) {
  let banner = props.banner;
  let actions = props.actions;
  let filters = props.filters;
  if (filters === undefined && actions === undefined && banner === undefined) {
    return JsxRuntime.jsx(Box.make, {
      spaceY: "normal"
    });
  }
  return JsxRuntime.jsxs(Box.make, {
    children: [
      JsxRuntime.jsxs(Inline.make, {
        children: [
          filters !== undefined ? filters : null,
          actions !== undefined ? actions : null
        ],
        align: filters !== undefined && filters !== null ? "spaceBetween" : "end"
      }),
      banner !== undefined ? banner : null
    ],
    spaceY: "medium"
  });
}

let make = BarControl;

export {
  make,
}
/* Box Not a pure module */
